"use client";

import AboutUsHero from "src/components/molecules/AboutUsSections/AboutUsHero";
import AboutUsStory from "src/components/molecules/AboutUsSections/AboutUsStory";
import AboutUsCoreValues from "src/components/molecules/AboutUsSections/AboutUsCoreValues";
import AboutUsExperts from "src/components/molecules/AboutUsSections/AboutUsExperts";

export default function AboutUsComponent({ teamMembers }) {
  return (
    <div className="bg-background-primary overflow-hidden">
      <AboutUsHero />
      <AboutUsStory />
      <AboutUsCoreValues />
      <AboutUsExperts teamMembers={teamMembers} />
    </div>
  );
}
